// ----------------------------------------------------------------------------
// Component:  Guarantees Bar
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import './_guarantee-bar.scss';